var map = {
	"./breakfast1.png": 61,
	"./breakfast2.png": 62,
	"./breakfast3.png": 63,
	"./breakfast4.png": 64,
	"./breakfast5.png": 65,
	"./breakfast6.png": 66,
	"./dinner1.png": 67,
	"./dinner2.png": 68,
	"./dinner3.png": 69,
	"./dinner4.png": 70,
	"./dinner5.png": 71,
	"./dinner6.png": 72,
	"./lunch1.png": 73,
	"./lunch2.png": 74,
	"./lunch3.png": 75,
	"./lunch4.png": 76,
	"./lunch5.png": 77,
	"./lunch6.png": 78
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;